<template>
  <div class="member-area-modules-content-header row align-items-center pb-3">
    <div class="col-lg-6 py-5">
      <div class="d-flex align-items-center">
        <span class="text-accent-105">Total: {{ modules.length }}</span>
        <button
          class="btn btn-sm btn-square-sm text-accent-105 font-weight-bold p-5"
          @click="$emit('refresh')"
        >
          <i class="icon-refresh" />
        </button>
      </div>
    </div>
    <div class="col-lg-6 py-5">
      <div class="d-flex align-items-center justify-content-end">
        <search-filter
          class="flex-fill"
          placeholder="Pesquisar"
          v-model="params.search"
          :showResultsDropdown="false"
          size="md"
        />
        <div class="mx-3"></div>
        <b-dropdown
          right
          text="Right align"
          class="btn btn-sm btn-40 btn-primary p-0"
        >
          <template #button-content>
            <div class="d-flex justify-content-between align-items-center">
              <i class="icon-plus pr-5"></i>
              <span class="pr-5">Novo módulo</span>
              <i class="icon-angle-down fs-16"></i>
            </div>
          </template>
          <b-dropdown-item>
            <router-link
              :to="{
                name: 'product-members-module-add',
                params: { id: $route.params.id }
              }"
            >
              <i class="fa-solid fa-book mr-3"></i>
              Módulo em branco
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('copy-module')">
            <i class="icon-filled-clone ml-n1 mr-3"></i>
            Copiar módulo existente
          </b-dropdown-item>
          <b-dropdown-item :disabled="final_quiz">
            <router-link
              :to="{
                name: 'product-members-module-quizz-final-add',
                params: { id: $route.params.id }
              }"
            >
              <i class="fa-solid fa-file-pen mr-2"></i>
              Avaliação final
            </router-link>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    final_quiz: {
      type: Object,
      default: () => {}
    },
    modules: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
.member-area-modules-content-header {
  .dropdown-item {
    a {
      color: unset !important;
      text-decoration: none;
    }
    i {
      font-size: 16px;
    }
  }
}
</style>
